import React from 'react';

import classes from './forEmployees.module.scss';

export const ForEmployees = () => {
  return (
    <div className={classes.ForEmployees}>
      <div className={classes.ForEmployeesSection}>
        <div className={classes.ForEmployeesLabel}>For Employees</div>
        <div className={classes.ForEmployeesTitle}>
          Personalized benefits guidance. Real financial support.
        </div>
        <div className={classes.ForEmployeesDescription}>
          Employees get a built-in benefits advisor that delivers:
        </div>
        
        <div className={classes.ForEmployeesList}>
          <div className={classes.ForEmployeesListItem}>
            • Expert-level decision support
          </div>
          <div className={classes.ForEmployeesListItem}>
            • Financial wellness coaching
          </div>
          <div className={classes.ForEmployeesListItem}>
            • Ongoing support throughout the enrollment journey
          </div>
        </div>
      </div>
    </div>
  );
};